// extracted by mini-css-extract-plugin
module.exports = {"root":"BudgetField__root___1UGEV","separator":"BudgetField__separator___3oHhY"};